import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useImagery } from "@/hooks/useCatalog";

export function NewsletterSection() {
  const { data } = useImagery();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data: res } = await api.post("/newsletter", { email });
      toast.success(res.message || "You're on the list!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="relative overflow-hidden" data-testid="newsletter-section">
      <img src={data?.newsletter} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-ink/70" />
      <div className="relative mx-auto max-w-2xl px-4 py-20 text-center sm:px-6 lg:py-28">
        <span className="text-luxe text-xs font-medium text-gold">Join The List</span>
        <h2 className="mt-4 font-serif text-3xl font-light text-ivory sm:text-4xl lg:text-5xl">Stay in the Glow</h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ivory/75 sm:text-base">
          Sign up for exclusive offers, new arrivals and jewellery inspiration.
        </p>
        <form onSubmit={subscribe} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            data-testid="newsletter-email-input"
            className="flex-1 border border-ivory/30 bg-ivory/10 px-4 py-3.5 text-sm text-ivory placeholder:text-ivory/50 backdrop-blur-sm focus:border-gold focus:outline-none"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="newsletter-submit-button"
            className="bg-gold px-8 py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-gold-dark disabled:opacity-60"
          >
            {busy ? "…" : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
}
